import { c as _c } from "react-compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Settings01 = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    });
    t1 = /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M18.7273 14.7273a1.5 1.5 0 0 0 .3 1.6545l.0545.0546a1.818 1.818 0 0 1 0 2.5727 1.8184 1.8184 0 0 1-2.5727 0l-.0546-.0546a1.5 1.5 0 0 0-1.6545-.3 1.5 1.5 0 0 0-.9091 1.3728v.1545a1.8182 1.8182 0 1 1-3.6364 0V20.1a1.5 1.5 0 0 0-.9818-1.3727 1.5002 1.5002 0 0 0-1.6545.3l-.0546.0545a1.818 1.818 0 0 1-1.9826.3947 1.82 1.82 0 0 1-.59-.3947 1.818 1.818 0 0 1-.5333-1.2863 1.818 1.818 0 0 1 .5332-1.2864l.0545-.0546a1.5 1.5 0 0 0 .3-1.6545 1.5 1.5 0 0 0-1.3727-.9091h-.1545a1.818 1.818 0 0 1-1.2857-3.1038 1.818 1.818 0 0 1 1.2857-.5326H3.9a1.5 1.5 0 0 0 1.3727-.9818 1.5 1.5 0 0 0-.3-1.6545l-.0545-.0546a1.818 1.818 0 0 1 0-2.5727 1.818 1.818 0 0 1 2.5727 0l.0545.0545a1.5 1.5 0 0 0 1.6546.3h.0727a1.5 1.5 0 0 0 .9091-1.3727v-.1545a1.8182 1.8182 0 0 1 3.6364 0V3.9a1.4997 1.4997 0 0 0 .9091 1.3727 1.5 1.5 0 0 0 1.6545-.3l.0546-.0545a1.817 1.817 0 0 1 1.2863-.5333 1.818 1.818 0 0 1 1.2864.5333 1.819 1.819 0 0 1 .3946 1.9826 1.82 1.82 0 0 1-.3946.5901l-.0546.0545a1.501 1.501 0 0 0-.3 1.6546v.0727a1.5 1.5 0 0 0 1.3728.9091h.1545a1.8183 1.8183 0 0 1 0 3.6364H20.1a1.4995 1.4995 0 0 0-1.3727.9091"
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = /*#__PURE__*/_jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [t0, t1]
    });
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Settings01;
//# sourceMappingURL=Settings01.js.map